import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudentSelect = _resolveComponent("StudentSelect")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_CourseSelect = _resolveComponent("CourseSelect")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isVisible) = $event)),
    modal: "",
    header: _ctx.$t('admin_components.course_registration_modal.view.title'),
    draggable: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        ref: "form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.postItemApi && _ctx.postItemApi(...args)), ["prevent"]))
      }, [
        _createVNode(_component_FormField, {
          label: _ctx.$t('admin_components.course_registration_modal.view.student')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StudentSelect, {
              disabled: this.student != undefined,
              modelValue: _ctx.courseRegistration.student,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.courseRegistration.student) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_FormField, {
          label: _ctx.$t('admin_components.course_registration_modal.view.course')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CourseSelect, {
              disabled: this.course != undefined,
              modelValue: _ctx.courseRegistration.course,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.courseRegistration.course) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_FormField, {
          label: _ctx.$t('admin_components.course_registration_modal.view.is_free')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ToggleSwitch, {
              modelValue: _ctx.courseRegistration.isFree,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.courseRegistration.isFree) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_Button, {
          type: "submit",
          label: _ctx.$t('admin_components.course_registration_modal.view.button'),
          disabled: !_ctx.isValid
        }, null, 8, ["label", "disabled"])
      ], 544)
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}